<template>
  <div>

    <template v-if="$store.state.isMobile == 2">
      <div class="main">
        <div class="top_native">
          <!-- <div class="newTitle animate__animated animate__zoomIn">
  <span>资讯动态</span>
</div> -->
          <template v-for="item in bannerList">
            <img class="bannerImg" :src="item.imgUrl" alt="">
            <div class="newTitle animate__animated animate__zoomIn">
              <div class="bannerText">
                <div class="chinese" v-html="item.titleMain"></div>
                <div class="engli" v-html="item.titleAssistant"></div>
              </div>
            </div>
          </template>
          <Banner v-if="$store.state.editStatus === 0" :type="1" :list="bannerList" @onReturn="bannerDate" />
        </div>
        <div class="navBar">
          <div class="menu">
            <template v-for="(item, index) in tableData">
              <div class="menuItem" @click="onTab(item)" :class="active_index == item.keyValue ? 'active' : ''">
                <span>{{ item.keyName }}</span> / {{ item.keyEnName }}
              </div>
            </template>
          </div>
          <Newstype v-if="$store.state.editStatus === 0" :list="tableData" />
        </div>
        <div class="newsList">
          <div class="example" v-for="(item, index) in listData" :key="index">
            <div class="list">
              <img :src="item.imgUrl" />

              <div class="rightCont">
                <div class="newTitle">
                  <div>
                    <img src="@/assets/img/icon/list.png" />
                    <span @click="openNews(item)">{{ item.title }}</span>
                  </div>
                  <div class="time">{{ editDate(item.gzhDate) }}</div>
                </div>
                <p>{{ item.content }}</p>
                <el-button @click="openNews(item)">查看详情</el-button>
              </div>
              <ListEdit v-if="$store.state.editStatus === 0" :data="item" @onReturn="() => { pageNum = 1; getList() }" />
            </div>
          </div>
          <EditNews v-if="$store.state.editStatus === 0" @onReturn="() => { pageNum = 1; getList() }" />
        </div>
        <div class="pages">
          <el-pagination small layout="prev, pager, next" :total="total" @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
          </el-pagination>
        </div>
        <CopyRight></CopyRight>
      </div>
    </template>
    <template v-else>
      <mobileNews />
    </template>
  </div>
</template>
<script>
import { banner } from "@/api/public"
import { getInformationList, getCommonDataList } from "@/api/news"
import mobileNews from "../mobile/mobileNews.vue"
export default {
  name: "News",
  components: {
    mobileNews
  },
  data() {
    return {
      pageNum: 1,
      total: 0,
      active_index: "",
      bannerList: [],
      tableData: [],
      // 市场动态资讯
      listData: [],
      // 公司活动资讯
      listData2: [],
    };
  },
  mounted() {
    if (this.$store.state.isMobile == 2) {
      banner({ isRelease: this.$store.state.editStatus, type: 1 }).then(res => {
        this.bannerList = res.data;
      })
      this.tableData = [];
      getCommonDataList({ commonData: 'information', isRelease: this.$store.state.editStatus }).then(res => {
        this.tableData = res.data;
        this.active_index = res.data[0].keyValue
        this.pageNum = 1;
        this.listData = [];
        this.getList();
      })

      window.scrollTo(0, 0);
      console.log(this.$route.query.type);
      if (this.$route.query.type == "market") {
        this.active_index = 0;
      } else if (this.$route.query.type == "activity") {
        this.active_index = 1;
      }
    }

  },
  methods: {
    pdfUrl(url) {

      let d = new Date()
      this.$router.push({ path: '/bdpdf', query: { name: url, t: d.getTime() } });
    },
    editDate(data) {
      if (data) {
        let arr = data.split(' ');
        return arr[0]
      } return ""

    },
    onTab(data) {
      this.active_index = data.keyValue;
      this.pageNum = 1;
      this.listData = [];
      this.getList()
    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.pageNum = 1;
      this.listData = [];
      this.getList()
    },
    handleCurrentChange(e) {
      this.pageNum = e;
      this.listData = [];
      this.getList()
    },
    getList() {
      let params = {
        pageNum: this.pageNum,
        pageSize: 10,
        type: this.active_index,
        isRelease: this.$store.state.editStatus

      }
      getInformationList(params).then(res => {
        this.listData = res.data.list;
        this.total = res.data.total;

      })
    },
    openNews(data) {
      let url=data.detailUrl
      if (url.indexOf('pdf') > -1) {
        let d = new Date()
        this.$router.push({ path: '/bdpdf', query: { name: url, t: d.getTime() } });
      } else if (url.indexOf('<p>') > -1 ) {
        this.$store.commit('setHtmlCont',data)
        this.$router.push({ path: '/newsDetail'})
       
      } else {
        window.open(url);
      }

    },
    bannerDate(v) {
      this.bannerList = JSON.parse(JSON.stringify(v))
    },

  },
};
</script>

<style lang="scss" scoped>
.main {
  margin-top: 60px;

  >div {
    width: 100%;
    background-size: cover;
  }
}

.top_native {
  height: 500px;
  text-align: left;
  position: relative;

  .bannerImg {
    width: 100%;
    height: 500px;
    position: absolute;
    top: 0;
  }

  .bannerText {
    position: absolute;
    top: 150px;
    left: 180px;
  }

  .newTitle {
    font-size: 60px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #003988;
    position: relative;

    span {
      width: 374px;
      height: 85px;
    }
    .engli {
      font-size: 50px;
      padding: 10px 20px;
      width: fit-content;
      color: #fff;
      background: #00398a;
      font-style: italic;
    }
  }
}

.navBar {
  height: 70px;
  background: #f2f5f9;
  padding: 0 180px;
  box-sizing: border-box;
  position: relative;

  .menu {
    display: flex;
    position: relative;

    .menuItem {
      cursor: pointer;
      font-size: 20px;
      font-family: Source Han Sans CN;
      line-height: 67px;
      color: #b5b5b5;
      margin-right: 100px;
      display: flex;
      z-index: 2;

      span {
        display: block;
        color: #00398a;
        margin-right: 5px;
        font-weight: 700;
      }
    }

    .active {
      span {
        color: #d7000f;
        border-bottom: 3px solid #d7000f;
      }
    }
  }
}

.newsList {
  // height: 1335px;
  background: url("../../assets/img/news/list_back.png") no-repeat center;
  text-align: left;
  font-family: Source Han Sans CN;
  position: relative;
  padding: 20px 180px;
  box-sizing: border-box;

  .example {
    position: relative;
    // z-index: 99;
    z-index: 1;
    margin-bottom: 20px;

    .list {
      display: flex;
      position: relative;

      p {
        text-indent: 2em;
      }
    }

    img {
      width: 409px;
      height: 257px;
    }

    .rightCont {
      margin-left: 30px;
      position: relative;
    }

    .newTitle {
      display: flex;
      justify-content: space-between;

      img {
        width: 20px;
        height: 27px;
        margin-right: 10px;
        position: relative;
        top: 5px;
      }

      span,
      .time {
        height: 23px;
        font-size: 20px;
        font-weight: 600;
        color: #333333;
        line-height: 27px;
      }

      .time {
        font-weight: normal;
      }
    }

    p {
      width: 1095px;
      height: 174px;
      font-size: 14px;
      color: #6a6a6a;
      line-height: 27px;
      margin-top: 10px;
    }
  }
}
</style>
